
import { environment } from 'src/environments/environment';
import { ProgramacionCorreoDto } from '../administracion/data/programacionCorreoDto';

export const reportesFeatureKey = environment.keyReportes;

export interface ReportesState {
  programacion: ProgramacionCorreoDto;

}

export const initialState: ReportesState = {
  programacion: {}

};


